module.exports = __webpack_public_path__ + "static/fonts/manrope-medium.d67747cf.woff2";